import React from 'react'

import FooterCopyright from './FooterCopyright/FooterCopyright'

import s from './Minimal.scss'

import facebook from './images/facebook.svg'
import twitter from './images/twitter.svg'
import pinterest from './images/pinterest.svg'
import instagram from './images/instagram.svg'


const socials = [
  {
    image: instagram,
    link: 'https://instagram.com/scentbird/',
    name: 'Instagram',
    ariaLabel: 'Instagram',
  },
  {
    image: facebook,
    link: 'https://www.facebook.com/scentbird',
    name: 'Facebook',
    ariaLabel: 'Facebook',
  },
  {
    image: twitter,
    link: 'https://www.twitter.com/scentbird',
    name: 'Twitter',
    ariaLabel: 'Twitter',
  },
  {
    image: pinterest,
    link: 'https://www.pinterest.com/scentbird/',
    name: 'Pinterest',
    ariaLabel: 'Pinterest',
  },
]


const Minimal = ({ withCopyright }) => (
  <div className={s.footer}>
    <div className={s.icons}>
      {
        socials.map(({ image, link, name, ariaLabel }) => (
          <a
            key={link}
            className={s.icon}
            href={link}
            rel="noopener noreferrer nofollow"
            target="_blank"
            aria-label={ariaLabel}
          >
            <img className={s.image} src={image} alt={name} />
          </a>
        ))
      }
    </div>
    {
      withCopyright && (
        <FooterCopyright />
      )
    }
  </div>
)


export default Minimal
